import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { CheckCircle, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { refresh } = useAuth();
  const [status, setStatus] = useState("polling");
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sessionId) return;
    const iv = setInterval(async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          refresh();
          clearInterval(iv);
        }
      } catch {}
      setTries(t => {
        if (t >= 12) { clearInterval(iv); setStatus("timeout"); }
        return t + 1;
      });
    }, 2000);
    return () => clearInterval(iv);
  }, [sessionId, refresh]);

  return (
    <div className="max-w-md mx-auto cw-card p-8 text-center anim-fade-up">
      {status === "polling" && (
        <>
          <Loader2 className="w-10 h-10 mx-auto mb-4 animate-spin text-red-500" />
          <h1 className="text-2xl font-display font-bold mb-2">Confirmando pagamento…</h1>
          <p className="text-zinc-400 text-sm">Isso leva alguns segundos.</p>
        </>
      )}
      {status === "paid" && (
        <>
          <CheckCircle className="w-14 h-14 mx-auto mb-4 text-emerald-500" />
          <h1 className="text-2xl font-display font-bold mb-2">Pagamento confirmado!</h1>
          <p className="text-zinc-400 text-sm mb-6">Você agora é CarnesWork Premium.</p>
          <Link to="/dashboard" className="cw-btn-primary inline-block">Voltar ao painel</Link>
        </>
      )}
      {status === "timeout" && (
        <>
          <h1 className="text-2xl font-display font-bold mb-2">Aguardando confirmação</h1>
          <p className="text-zinc-400 text-sm mb-6">Seu pagamento pode levar mais tempo. Volte em instantes.</p>
          <Link to="/dashboard" className="cw-btn-outline inline-block">Voltar</Link>
        </>
      )}
    </div>
  );
}
